const Unauthorized = () => {
    return (
        <div>
            <h2 align="center">Unauthorized</h2>
        </div>

    );
};
export default Unauthorized;